import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn';
const TINTS = {
    sage: 'bg-bleu-gris-light text-ink-on-tint',
    rose: 'bg-cream-dark text-ink',
    lila: 'bg-bleu-gris-light text-ink-on-tint',
    cream: 'bg-cream-dark text-ink-soft',
};
/*
 * The disc is a fixed-dark surface (`bg-surface-ink`, navy in both themes),
 * so the glyph is the pinned amande `text-on-surface-ink`; no accent on it.
 */
const INK_GLYPH = {
    sage: 'text-on-surface-ink opacity-80',
    rose: 'text-on-surface-ink opacity-80',
    lila: 'text-on-surface-ink opacity-80',
    cream: 'text-on-surface-ink',
};
export function PageHeader({ title, sub, icon, tint = 'cream', variant = 'tile', actions, className, }) {
    const ink = variant === 'ink-circle';
    return (_jsxs("header", { className: cn('flex flex-wrap gap-4', ink ? 'items-start' : 'items-center', className), children: [icon ? (_jsx("span", { className: cn('grid flex-none place-items-center', ink
                    ? cn('h-[52px] w-[52px] rounded-full bg-surface-ink', INK_GLYPH[tint])
                    : cn('h-12 w-12 rounded-[14px]', TINTS[tint])), children: icon })) : null, _jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("h1", { className: cn('font-serif font-medium text-ink', ink
                            ? 'text-[clamp(26px,3.2vw,36px)] leading-[1.06]'
                            : 'text-[clamp(26px,3vw,34px)] leading-[1.08]'), children: title }), sub ? (_jsx("p", { className: cn('text-[14.5px] leading-[1.5] text-muted', ink ? 'mt-2 max-w-[58ch]' : 'mt-1.5 max-w-[60ch]'), children: sub })) : null] }), actions ? _jsx("div", { className: "flex flex-none items-center gap-2", children: actions }) : null] }));
}
/**
 * `.pro-page-head` — how every PRACTITIONER page opens.
 *
 * A third header shape, and the difference from `PageHeader` is not decoration:
 * there is no icon and the heading is the SANS face, not the serif display one
 * (measured off the handoff: `Inter Tight` 30px/700 against `PageHeader`'s
 * clamped Rosario). Pro Resources, Case Studies and the Cohort Journey all open
 * this way — a small navy eyebrow naming the section, the title, and one line of
 * orientation capped at 640px.
 *
 * The eyebrow is what makes it work: these screens sit inside a portal a member
 * shares with two other portals, and "PRO LIBRARY" over "Pro Resources" says
 * which one you are in before the title has to.
 */
export function ProPageHead({ eyebrow, title, sub, className, }) {
    return (_jsxs("header", { className: cn('mb-1.5', className), children: [_jsx("p", { className: "text-[11px] font-semibold uppercase tracking-[0.14em] text-ink", children: eyebrow }), _jsx("h1", { className: "mb-2 mt-1 font-serif text-[30px] font-medium leading-[1.15] text-ink", children: title }), sub ? _jsx("p", { className: "max-w-[640px] text-[14.5px] leading-[1.6] text-slate", children: sub }) : null] }));
}
//# sourceMappingURL=page-header.js.map